var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockquote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 52,
    viewBox: "0 0 69 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_4292)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_527_4292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.314 0.187866L28.039 6.75587C25.948 9.58987 24.019 12.7449 22.255 16.2219C20.49 19.6989 19.477 23.3049 19.215 27.0399L30 28.9719V51.1879H0V35.3479C0 26.2029 2.19 18.8299 6.569 13.2279C10.948 7.62587 16.863 3.27787 24.314 0.187866ZM63.314 0.187866L67.039 6.75587C64.948 9.58987 63.019 12.7449 61.255 16.2219C59.49 19.6989 58.477 23.3049 58.215 27.0399L69 28.9719V51.1879H39V35.3479C39 26.2029 41.19 18.8299 45.569 13.2279C49.948 7.62587 55.863 3.27787 63.314 0.187866Z",
    fill: "#E6EBEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_4292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 51,
    fill: "white",
    transform: "translate(0 0.187866)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_527_4292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 51,
    fill: "white",
    transform: "translate(0 0.187866)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockquote);
export default __webpack_public_path__ + "static/media/Blockquote.d9f43576b80dbe4c9b4e6daac4a92031.svg";
export { ForwardRef as ReactComponent };